module.exports = __webpack_public_path__ + "img/icon-location.4830240.png";